/**
 * @Author: 韩祺涛
 * @Date: 2023-03-17
 * @Project: 杭氧客户现场使用
 */
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取左侧部门树
export function getCompanyTree (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/company/companyTree',
    method: 'GET',
    params: parameter
  })
}
// 获取左侧设备列表
export function getEquipmentTree (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/list',
    // url: '/data/equipmentList.json',
    // url: sysInfo.apiRemote + '/asset/list',
    method: 'GET',
    params: parameter
  })
}
// 获取设备表格
export function getEquipmentTableData (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/listByPid',
    method: 'GET',
    params: parameter
  })
}
// 设备统计
export function getEquipmentTableTotal (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/statistics',
    method: 'GET',
    params: parameter
  })
}
// 获取设备信息
export function getEquipmentBasicInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/info',
    // url: '/data/equipmentInfo.json',
    method: 'GET',
    params: parameter
  })
}
// 获取使用部门树
export function getDeptTreeList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/company/companyTree',
    // url: '/data/assetDept.json',
    method: 'GET',
    params: parameter
  })
}
// 获取使用部门下拉数据
export function getUserDepartmentList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/company/deptTree',
    method: 'GET',
    params: parameter
  })
}
// 获取归口部门下拉数据
export function getfocalDepartmentsList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/relevantsByAuth',
    method: 'GET',
    params: parameter
  })
}
// 获取设备状态/专项类型/SAP设备分类
export function getDictList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/query',
    method: 'GET',
    params: parameter
  })
}
// 获取设备业务费用信息
export function getEquipmentExpense (parameter) {
  return axios({
    url: '/data/equipmentExpense.json',
    // url: sysInfo.apiRemote + '',
    method: 'GET',
    params: parameter
  })
}
// 获取设备备件信息
export function getEquipmentSpareParts (parameter) {
  return axios({
    url: '/data/equipmentSpareParts.json',
    // url: sysInfo.apiRemote + '',
    method: 'GET',
    params: parameter
  })
}
// 获取设备备件信息
export function getEquipmentDocument (parameter) {
  return axios({
    url: '/data/equipmentDocument.json',
    // url: sysInfo.apiRemote + '',
    method: 'GET',
    params: parameter
  })
}
// 获取编辑记录
export function getEditRecord (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/update/record/list',
    method: 'GET',
    params: parameter
  })
}
// 新增/编辑设备
export function addOrEditEquipment (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment',
    method: 'POST',
    data: parameter
  })
}
// 删除设备
export function delEquipment (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment',
    method: 'DELETE',
    params: parameter
  })
}
// 导入模板下载
export function equipmentTemplate (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/download/template/${parameter.fileType}`,
    method: 'GET',
    responseType: 'blob'
    // params: parameter
  })
}
// 设备导入
export function equipmentImport (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/equipment/import`,
    method: 'POST',
    // responseType: 'blob',
    data: parameter
  })
}
// 设备导入
export function getEquipmentExport (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/equipment/export`,
    responseType: 'blob',
    // timeout: 5 * 60 * 1000,
    method: 'GET',
    params: parameter
  })
}
// 获取设备子集树
export function getEquipmentTreeByPid (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/treeByPid',
    method: 'GET',
    params: parameter
  })
}
// 设备整树
export function getEquipmentTreeByLevelOneId (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/treeByLevelOneId',
    method: 'GET',
    params: parameter
  })
}
